import React from 'react';
import { Box, Checkbox, FormControlLabel, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';
import SectionCard from './SectionCard';

export default function RemoteDesktopSection({ form, setField, provider, fillHeight }) {
    const clusterSettings = useSelector(({ settings }) => settings.settings.clusterSettings);
    const orgClusterSettings = useSelector(({ settings }) => settings.settings.orgClusterSettings);

    const hprdEnabled = orgClusterSettings?.clusterSettings?.enableHighPerformanceRemoteDesktop
        || clusterSettings?.enableHighPerformanceRemoteDesktop;

    const dcvCaption = provider === 'aws'
        ? 'Install high-performance remote desktop during deployment (free on AWS EC2)'
        : 'Install high-performance remote desktop during deployment (requires license for non-AWS)';

    return (
        <SectionCard icon="desktop_windows" title="Remote Desktop Settings" fillHeight={fillHeight}>
            <Box display="flex" justifyContent="space-between">
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={form.vncTokenAuthentication || false}
                            onChange={(e) => setField('vncTokenAuthentication', e.target.checked)}
                            name="vncTokenAuthentication"
                            color="primary"
                        />
                    }
                    label="Token Authentication"
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={form.vncRemoteClient || false}
                            onChange={(e) => setField('vncRemoteClient', e.target.checked)}
                            name="vncRemoteClient"
                            color="primary"
                        />
                    }
                    label="Remote Client"
                />
            </Box>
            {hprdEnabled && (
                <Box mt={1}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={form.dcvEnabled || false}
                                onChange={(e) => setField('dcvEnabled', e.target.checked)}
                                name="dcvEnabled"
                                color="primary"
                            />
                        }
                        label="High Performance Remote Desktop"
                    />
                    <Typography variant="caption" color="textSecondary" display="block" style={{ marginLeft: 32 }}>
                        {dcvCaption}
                    </Typography>
                </Box>
            )}
        </SectionCard>
    );
}
